// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9175) return "static/chunks/9175-14714c82392f617b.js";
	if (chunkId === 3850) return "static/chunks/3850-69678ef8a2030b20.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2745":"9bfe93d34d04e84d","8025":"3cf415dc496c10b7"}[chunkId] + ".js";
};